import { Box, Button, Typography, useTheme, useMediaQuery, TextField } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { tokens } from "../../theme";
import Header from "../../components/Header";
import axios from 'axios';
import { Tooltip } from '@mui/material';
import { AuthContext } from '../../context/AuthContext';
import { useContext, useEffect, useState } from "react";
import { useNavigate, Link, useParams } from "react-router-dom";
import SettingsIcon from '@mui/icons-material/Settings';

const NewRequest = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [suppliers, setSuppliers] = useState(null);
  const { currentuser, base_url, request } = useContext(AuthContext);
  const navigate = useNavigate();
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down('sm'));
  const [pdfUrl, setPdfUrl] = useState(null);
  const [remark, setRemark] = useState(null);
  const [product, setProduct] = useState(request?.product || null);
  const [company, setCompany] = useState(request?.product.company || null);
  const [order, setOrder] = useState(request || null);
  const [showRemarkField, setShowRemarkField] = useState(false);
  const [imageUrl, setImageUrl] = useState(null);
  let { id } = useParams();

  const config = {
    headers: {
      'Authorization': `Bearer ${currentuser.token}`
    }
  };

  const configBlob = {
    headers: {
      'Authorization': `Bearer ${currentuser.token}`
    },
    responseType: 'blob',
  };

  const handleApprove = async () => {
    await axios.post(base_url + '/ethioglobal/request/approve', {id: id}, config).then((res) => {
      alert('Approved.');
    }).catch((error) => {
      if(error.status == 404){
        alert('Supplier not found.');
      } else {
        alert('An error occurred.');
      }
    });
    navigate(`/requests`)
  };

  const handleReject = () => {
    setShowRemarkField(true);
  };

  const handleRemarkSubmit = async () => {
    await axios.post(base_url + '/ethioglobal/request/reject', {id: id, remark: remark}, config).then((res) => {
      alert('Rejected.');
    }).catch((error) => {
      if(error.status == 404){
        alert('Supplier not found.');
      } else {
        alert('An error occurred.');
      }
    });
    setShowRemarkField(false);
    setRemark('');
    navigate(`/requests`)
  };

  const fetchDocuments = async () => {
    try {
      const res = await axios.get(`${base_url}/ethioglobal/docs/pdf/Shentam.pdf`, configBlob);
      
      const pdfBlob = new Blob([res.data], { type: 'application/pdf' });
      const pdfUrl = window.URL.createObjectURL(pdfBlob);
      setPdfUrl(pdfUrl);
    } catch (error) {
      console.log('error: ', error);
    }
  };

  // useEffect(() => {
  //   fetchDocuments();
  // }, []);

  useEffect(() => {
    const fetchImage = async (image) => {
      try {
        const response = await axios.get(base_url + '/ethioglobal/image/' + image, configBlob);

        if (!response.status == 200) {
          throw new Error('Network response was not ok');
        }

        const imageBlob = new Blob([response.data], { type: 'image/jpeg' });
        const imageObjectURL = window.URL.createObjectURL(imageBlob);

        setImageUrl(imageObjectURL);
      } catch (error) {
        console.error('Error fetching image:', error);
      }
    };

    // console.log('new request:', request);
    const imagePath = product?.productImage.split('/')[2];
    if(imagePath) {
      fetchImage(imagePath);
    }
  }, [request]);

  return (
    <Box m="20px" sx={{background: `${colors.primary[500]} !important`, padding: '10px'}}>
      {1 == 1 ? (
        <Box mt="20px" sx={{marginLeft: 5}}>
          <Box alignItems="center" justifyContent="space-between" gap={2}>
            <Typography>
              Product Name: {product?.productname}
            </Typography>
            <Typography sx={{marginTop: 1}}>
              Supplier Name: {company?.companyname}
            </Typography>
            {order?.status !== 'active' && order?.status !== 'closed' && order?.status !== 'suspended' && order?.status !== 'approved' &&
            <Box sx={{ marginTop: 2, flexDirection: { xs: 'column', sm: 'row' }, gap: { xs: 1, sm: 1 } }}>
              <Button variant="contained" color="primary" onClick={handleApprove} sx={{ marginRight: 1 }}>
                Approve
              </Button>
              <Button variant="contained" color="secondary" onClick={handleReject}>
                Reject
              </Button>
            </Box>
            }
          </Box>
          {showRemarkField && (
            <Box mt={2}>
              <TextField
                label="Remark"
                multiline
                rows={4}
                variant="outlined"
                fullWidth
                value={remark}
                onChange={(e) => setRemark(e.target.value)}
              />
              <Button variant="contained" color="primary" onClick={handleRemarkSubmit} sx={{ marginTop: 1, marginRight: '20px' }}>
                Submit Remark
              </Button>
              <Button variant="contained" color="primary" onClick={() => setShowRemarkField(false)} sx={{ marginTop: 1 }}>
                Cancel
              </Button>
            </Box>
          )}
          {imageUrl &&
            <Box sx={{ overflow: 'hidden', marginTop: 1, marginLeft: ''}}>
              <img src={imageUrl} alt="Fetched" style={{ width: 'auto', height: '450px' }} />
            </Box>
          }
        </Box>
      )
      :
      <Box>
        <Typography>The supplier didn't upload any documents yet.</Typography>
      </Box>
      }
    </Box>
  );
};

const overflowCellStyle = {
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
};

export default NewRequest;